(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ly-b2b"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-b2b]').forEach(function(root){
  var ar=document.documentElement.lang==='ar', C=ar?' ر.س':' SAR', PCS=ar?' قطعة':' pcs';
  var items=[].slice.call(root.querySelectorAll('[data-item]'));
  var rows=root.querySelector('[data-rows]'), tot=root.querySelector('[data-total]'), cnt=root.querySelector('[data-count]'), err=root.querySelector('[data-err]');
  function f(n){return n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});}
  function q(it){return Math.max(0,Math.floor(+it.querySelector('input').value||0));}
  function upd(){
    var t=0,n=0,h='',bad=false;
    items.forEach(function(it){var p=+it.dataset.p,m=+it.dataset.m,k=q(it),low=k%m!==0;
      it.classList.toggle('on',k>0); it.classList.toggle('low',low);
      it.querySelector('[data-line]').innerHTML=k?(low?(ar?'مضاعفات '+m:'Multiples of '+m):f(k*p)+C+'<small>'+(k/m)+(ar?' صينية':(k/m>1?' trays':' tray'))+'</small>'):'—';
      if(low){bad=true;return;} if(!k)return;
      t+=k*p; n++; h+='<div class="row"><span>'+it.dataset.name+' × '+k+' ('+(k/m)+(ar?' صينية':(k/m>1?' trays':' tray'))+')</span><span>'+f(k*p)+'</span></div>';});
    rows.innerHTML=h||'<div class="row"><span>'+(ar?'لم تختر شيئاً بعد':'Nothing added yet')+'</span><span></span></div>';
    tot.textContent=f(t); cnt.textContent=n?(ar?n+' أصناف':n+(n>1?' items':' item')):'';
    return {t:t,n:n,bad:bad};
  }
  items.forEach(function(it){
    var inp=it.querySelector('input'), m=+it.dataset.m;
    it.querySelectorAll('[data-d]').forEach(function(b){b.addEventListener('click',function(){
      var k=Math.round(q(it)/m)*m, d=+b.dataset.d;
      k=Math.max(0,k+d*m);
      inp.value=k; upd();});});
    inp.addEventListener('input',upd);
    inp.addEventListener('change',function(){var k=q(it); if(k%m) inp.value=Math.ceil(k/m)*m; upd();});
  });
  upd();
  root.querySelector('[data-go]').addEventListener('click',function(){
    var r=upd();
    var msg=r.bad?(ar?'بعض الكميات ليست صواني كاملة.':'Some quantities are not full trays.'):(!r.n?(ar?'أضف صنفاً واحداً على الأقل.':'Add at least one item.'):'');
    err.hidden=!msg; err.textContent=msg; if(msg) return;
    var list=items.filter(function(it){return q(it)>0;}).map(function(it){return {id:+it.dataset.v,quantity:q(it)/(+it.dataset.m)};});
    var b=this; b.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:list})})
      .then(function(res){if(!res.ok)throw res;location.href='/checkout';})
      .catch(function(){b.disabled=false;err.hidden=false;err.textContent=ar?'حدث خطأ، حاول مرة أخرى.':'Something went wrong — please try again.';});
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ly-catering"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cat]').forEach(function(root){
  /* Volume tiers by total cups/pieces across all items — derived from the coffee price list
     (100=2,200 / 150=3,200 / 200=4,200 / 250=5,100 / 300=6,100 vs 29/cup). Must match the automatic discounts in Shopify. */
  var T=[]; /* flat rates — no volume discounts */
  var ar=document.documentElement.lang==='ar', C=ar?' ر.س':' SAR';
  var items=[].slice.call(root.querySelectorAll('[data-item]'));
  var rows=root.querySelector('[data-rows]'), totEl=root.querySelector('[data-total]');
  var dRow=root.querySelector('[data-disc-row]'), dLbl=root.querySelector('[data-disc-lbl]'), dVal=root.querySelector('[data-disc]'), hint=root.querySelector('[data-hint]');
  var addRow=root.querySelector('[data-addon-row]'), addChk=root.querySelector('[data-addon-chk]');
  var addonId=+root.dataset.addon||0, addonP=parseFloat(root.dataset.addonPrice)||0;
  function fmt(n){return (Math.round(n*100)/100).toLocaleString('en-US',{maximumFractionDigits:2});}
  function rate(q){for(var i=0;i<T.length;i++){if(q>=T[i][0])return T[i][1];}return 0;}
  function next(q){for(var i=T.length-1;i>=0;i--){if(q<T[i][0])return T[i];}return null;}
  function picks(){return items.map(function(it){var g=it.querySelector('[data-vid]'),r=it.querySelector('input:checked');return {it:it,id:+g.dataset.vid,u:parseFloat(g.dataset.unit),q:r?+r.value:0};}).filter(function(x){return x.q>0;});}
  function upd(){
    var ps=picks(), q=0, sub=0, slush=false, h='';
    ps.forEach(function(x){q+=x.q;sub+=x.q*x.u;if(x.it.dataset.slush==='true')slush=true;h+='<div class="row"><span>'+x.it.dataset.name+' × '+x.q+'</span><span>'+fmt(x.q*x.u)+'</span></div>';});
    var r=rate(q), d=sub*r;
    items.forEach(function(it){var g=it.querySelector('[data-vid]'),rr=it.querySelector('input:checked'),n=rr?+rr.value:0;it.querySelector('[data-line]').textContent=n?fmt(n*parseFloat(g.dataset.unit)*(1-r))+C:'—';it.classList.toggle('on',n>0);});
    rows.innerHTML=h||'<div class="row"><span>'+(ar?'لم تختر شيئاً بعد':'Nothing selected yet')+'</span><span></span></div>';
    dRow.hidden=!d; if(d){dLbl.textContent=(ar?'خصم الكمية ':'Volume discount ')+(r*100).toFixed(1)+'%';dVal.textContent='−'+fmt(d);}
    hint.textContent='';
    var tot=sub-d; if(addRow){addRow.hidden=!slush;if(slush&&addChk.checked)tot+=addonP;}
    totEl.textContent=fmt(tot);
  }
  root.addEventListener('change',upd); upd();
  root.querySelector('[data-go]').addEventListener('click',function(){
    var err=root.querySelector('[data-err]'), ps=picks(), d=root.querySelector('[data-date]').value, l=root.querySelector('[data-loc]').value.trim();
    var msg=!ps.length?(ar?'اختر كمية لصنف واحد على الأقل.':'Choose an amount for at least one item.'):(!d||!l)?(ar?'أدخل تاريخ المناسبة واختر المدينة.':'Add the event date and choose a city.'):'';
    err.hidden=!msg; err.textContent=msg; if(msg) return;
    var props={'Event date':d,'City':l}, list=ps.map(function(x){return {id:x.id,quantity:x.q,properties:props};});
    if(addRow&&!addRow.hidden&&addChk.checked&&addonId) list.push({id:addonId,quantity:1,properties:props});
    var b=this; b.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:list})})
      .then(function(r){if(!r.ok)throw r;location.href='/checkout';})
      .catch(function(){b.disabled=false;err.hidden=false;err.textContent=ar?'حدث خطأ، حاول مرة أخرى.':'Something went wrong — please try again.';});
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ly-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ly-pdp').forEach(function(root){
  var s=root.querySelector('[data-slider]'), th=[].slice.call(root.querySelectorAll('.ly-pdp__thumb'));
  function idx(){return Math.round(s.scrollLeft/s.clientWidth)*(document.dir==='rtl'?-1:1);}
  function go(i){var n=s.children.length; i=Math.max(0,Math.min(n-1,i)); s.scrollTo({left:i*s.clientWidth*(document.dir==='rtl'?-1:1),behavior:'smooth'});}
  root.querySelectorAll('.ly-pdp__nav').forEach(function(b){b.addEventListener('click',function(){go(Math.abs(idx())+(+b.dataset.dir));});});
  th.forEach(function(b){b.addEventListener('click',function(){go(+b.dataset.i);});});
  s.addEventListener('scroll',function(){var i=Math.abs(idx()); th.forEach(function(t,k){t.classList.toggle('on',k===i);});},{passive:true});
  root.querySelectorAll('[data-q]').forEach(function(b){b.addEventListener('click',function(){var q=root.querySelector('input[name=quantity]'); q.value=Math.max(1,(+q.value||1)+(+b.dataset.q));});});
  var bk=root.querySelector('[data-book]');
  if(bk){document.body.classList.add('ly-booking');
    var wn=root.querySelector('[data-warn]');
    var okd=false;
    function amodal(){return document.getElementById('appointo-modal');}
    function shutAuto(){var m=amodal(); if(!okd&&m&&m.style.display==='block'){var c=m.querySelector('.appointo-close'); if(c)c.click(); m.style.display='none';} if(!okd&&document.body.classList.contains('appointo-fixed'))document.body.classList.remove('appointo-fixed');}
    new MutationObserver(shutAuto).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class']});
    setTimeout(shutAuto,500);setTimeout(shutAuto,2000);
    function openBooking(){okd=true;document.body.classList.add('ly-book-ok');var b=document.getElementById('appointo-btn'); if(b){b.click();}else{bk.disabled=true;setTimeout(function(){bk.disabled=false;var b2=document.getElementById('appointo-btn'); if(b2)b2.click();},1500);}}
    function closeWarn(){wn.hidden=true;document.documentElement.classList.remove('ly-warn-open');}
    bk.addEventListener('click',function(){if(!wn){openBooking();return;} wn.hidden=false;document.documentElement.classList.add('ly-warn-open');wn.querySelector('[data-warn-ok]').focus();});
    if(wn){wn.querySelector('[data-warn-ok]').addEventListener('click',function(){closeWarn();openBooking();});
      wn.querySelector('[data-warn-x]').addEventListener('click',closeWarn);
      wn.addEventListener('click',function(e){if(e.target===wn)closeWarn();});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!wn.hidden)closeWarn();});}}
  var sel=root.querySelector('[data-variant]');
  if(sel) sel.addEventListener('change',function(){var o=sel.options[sel.selectedIndex]; root.querySelector('[data-price]').textContent=o.dataset.p;
    if(o.dataset.m){var sl=[].slice.call(s.children); for(var k=0;k<sl.length;k++){if(sl[k].dataset.mid===o.dataset.m){go(k);break;}}}
    var u=new URL(location.href); u.searchParams.set('variant',sel.value); history.replaceState(null,'',u);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
